import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import Loading from '../Shared/Loading';
import Project from './Project';




const AllProjects = () => {

    const navigate = useNavigate();

    const { data: projects, isLoading, refetch } = useQuery('projects', () =>
        fetch(`https://stark-wildwood-35883.herokuapp.com/projects`)
            .then(res => res.json())
    );

    if (isLoading) {
        return <Loading />
    }

    const getProjectById = id => {
        navigate(`/projects/${id}`);
        refetch();
    }

    return (
        <div className='py-6' id='products'>
            <div>
                <h3 className='text-center text-2xl uppercase font-semibold text-green-500'
                    data-aos="fade-down"
                    data-aos-duration="800"
                >Protfolio</h3>
                <h3 className='text-center text-3xl font-semibold py-2'
                    data-aos="fade-down"
                    data-aos-duration="1000"
                >LATEST WORKS</h3>
            </div>
            <div className='flex flex-wrap justify-center mb-5'
                data-aos="fade-down"
                data-aos-duration="1200"
            >
                <Link to='all' className='bg-green-500   text-white mr-3  px-4 py-1 rounded-2xl font-semibold ring-1 ring-indigo-600 ring-offset-1 mb-3 ' >All</Link>
                <Link to='desgin' className='bg-green-500    text-white mr-3  px-4 py-1 rounded-2xl font-semibold ring-1 ring-indigo-600 ring-offset-1 mb-3 ' >Web Design</Link>
                <Link to='development' className='bg-green-500   text-white mr-3  px-4 py-1 rounded-2xl font-semibold ring-1 ring-indigo-600 ring-offset-1  mb-3' >Web Development</Link>
                <Link to='photograpy' className='bg-green-500   text-white mr-3  px-4 py-1 rounded-2xl font-semibold ring-1 ring-indigo-600 ring-offset-1 mb-3 ' >Photograpy</Link>
            </div>
            <div className='grid gap-10  mb-10 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 pt-2 px-4'>
                {
                    projects.map(p => <Project key={p._id} getProjectById={getProjectById} refetch={refetch} p={p} />)
                }
            </div>
        </div>
    );
};

export default AllProjects;